<!--
  이벤트 참여 동의하기 모달 팝업
-->
<template>
  <mmp-modal
    v-bind="modalAttrs"
    :class="['event_join_agreement_modal', classes, {'no_header' : !header, 'no_footer' : !footer}, deviceType]"
    v-on="listeners"
  >

    <template
      v-slot:header
      v-if="header"
    >
      <div v-dompurify-html="title"/>
      <button type="button" class="btn_close" @click="$emit('close')">
        <span class="blind">팝업 닫기</span>
      </button>
    </template>

    <template v-slot:content>

      <div class="wrap_agreement">
        <p class="tit">약관동의</p>
        <p class="desc desc_1">
          (주)멀티캠퍼스는 학습자의 개인정보보호에 대한 권리를 소중하게 생각하고 이를 보호하기 위해 최선의 노력을 하고 있습니다.
        </p>

        <div class="wrap_policy_accordion">
          <div class="accordion_header">

            <div class="check_box">
              <input
                id="agreement_checkbox"
                ref="agreementCheckbox"
                v-model="isChecked"
                name="agreement_checkbox"
                type="checkbox"
                class="all_checkbox"
              >
              <label class="hidden" for="agreement_checkbox">
                <span>약관 동의하기</span>
              </label>
            </div>

            <div class="wrap_button">
              <button
                class="btn_tit"
                data-accordion-content="accordion_1"
                @click="toggleAccordion"
              >개인정보 수집 및 이용 동의(필수)</button>
            </div>

          </div>
          <div
            class="accordion_content"
            data-accordion-content="accordion_1"
          >
            <p class="txt">
              [개인정보 수집 및 이용 동의]<br>
              1. 수집목적 : 이벤트 참여 확인 및 진행, 경품 지급<br>
              2. 수집항목 : 멀티캠퍼스 아이디, 이름, 휴대폰 번호<br>
              3. 보유기간 : 경품 배송 완료 6개월 후 파기
            </p>
          </div>
        </div>

        <p class="desc desc_2">
          멀티캠퍼스는 이벤트 진행 및 경품 지급을 위한 업무를 다음과 같이 위탁합니다.<br>
          1. 수탁사 : (주)지에스엠비즈<br>
          2. 목적 : 이벤트 경품 발송
        </p>

        <!-- // 모델 확인창 퍼블 문제 해결시 삭제 필요 -->
        <div v-show="modalCheck" class="modal-wrap">
          <div class="modal-container">
            <br>
            <p>
              이미 이벤트에 참여하셨습니다.
            </p>
            <br>
            <br>
            <div class="wrap_footer_btn">
              <p>
                <button
                  class="btn__box-stroke-md"
                  @click="modalOpen"
                >닫기</button>
              </p>
            </div>
          </div>
        </div>

      </div>

    </template>
    <template
      v-slot:footer
      v-if="footer"
    >
      <div class="wrap_footer_btn">
        <button
          class="btn__box-stroke-md"
          @click="cancel()"
        >취소</button>
        <button
          class="btn__box-blue-md"
          @click="confirm()"
        >확인</button>
      </div>
    </template>

  </mmp-modal>
</template>

<script>
export default {
  name: 'EventJoinAgreementModal',
  props: {
    // full-page modal 적용 여부
    fullModal: {
      type: Boolean,
      default: true
    },
    useDefaultHeader: {
      type: Boolean,
      default: false
    },
    useDefaultFooter: {
      type: Boolean,
      default: false
    },
    // 헤더 자체 노출 여부
    header: {
      type: Boolean,
      default: true
    },
    // 푸터 자체 노출 여부
    footer: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    classes: {
      type: Array,
      default: null,
      required: false
    },
    bltndMstrSno: {
      type: String,
      default: '',
      required: true
    },
    bltndSno: {
      type: String,
      default: '',
      required: true
    },
    statusClass: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
      isDesktop: true, // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
      isChecked: false, // 동의하기 체크박스 체크 여부
      agrmtAgrYn: 'N',
      agrmtTerm: {
        termsAgrmtSetupNo: '',
        termsAgrmtSno: '',
        mltlnSetupCd: '',
        termsAgrmtKnd: '',
        termsVerno: '',
        termsAgrmtKndNm: '',
        termsAgrmtNm: '',
        dispTermsAgrmtNm: '',
        termsAgrmtPpuseScCd: '',
        termsAgrmtPpuseScCdNm: '',
        termsAgrmtAplcScCd: '',
        termsAgrmtAplcScCdNm: '',
        outMngrTyp: '',
        outMngrTypNm: '',
        mndtYn: '',
        termsCntnt: '',
        useYn: ''
      },
      modalCheck: false
    }
  },
  computed: {
    // 현재 디바이스 명 (pc, mobile, tablet)
    deviceType () {
      return window.vue.getStore('homeInfo').state.deviceType
    },
    isValidParam () {
      return true
    },
    modalAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: this.useDefaultHeader,
        useDefaultFooter: this.useDefaultFooter,
        fullModal: this.fullModal,
        title: this.title
      }
    }
  },
  created () {
    this.selectBoardAgrmtTgtAgrYn()
  },
  beforeMount () {

  },
  mounted () {

  },
  methods: {
    // 게시글 이벤트 동의여부 조회
    selectBoardAgrmtTgtAgrYn () {
      let params = {
        bltndMstrSno: this.bltndMstrSno,
        bltndSno: this.bltndSno
      }
      console.log('selectBoardAgrmtTgtAgrYn', params)
      this.fetchData('selectBoardAgrmtTgtAgrYn', params, (data) => {
        console.log('boardAgrmtTgt', data)
        this.agrmtAgrYn = data.agrmtAgrYn
        this.agrmtTerm = data.agrmtTerm
        // console.log('>>>>>>>>>>agrmtTerm', this.agrmtTerm)
      })
    },
    // 아코디언 UI 토글
    toggleAccordion (e) {
      const triggerBtn = e.target
      const accordionWrapper = triggerBtn.closest('.wrap_policy_accordion')

      if (accordionWrapper) accordionWrapper.classList.toggle('expand')
    },
    // 확인버튼 클릭 이벤트
    async confirm () {
      if (this.agrmtAgrYn === 'Y') {
        // this.modalCheck = !this.modalCheck
        await this.$popup.alert(this.$el, {title: '알림', contents: '이미 이벤트에 참여하셨습니다.'})
        this.$refs.agreementCheckbox.focus()
        return
      }
      if (this.statusClass === 'closed') {
        await this.$popup.alert(this.$el, {title: '알림', contents: '이벤트가 종료되었습니다.'})
        this.$refs.agreementCheckbox.focus()
        return
      }
      if (!this.isChecked) {
        await this.$popup.alert(this.$el, {title: '알림', contents: '약관에 동의해야만 이벤트 참여가 가능합니다. <br>약관 이용 동의에 체크해 주세요.'})
        this.$refs.agreementCheckbox.focus()
        return
      }

      let params = {
        bltndMstrSno: this.bltndMstrSno,
        bltndSno: this.bltndSno,
        termsVerno: this.agrmtTerm.termsVerno,
        termsAgrmtKnd: this.agrmtTerm.termsAgrmtKnd,
        termsAgrmtSno: this.agrmtTerm.termsAgrmtSno,
        termsAgrmtPpuseScCd: this.agrmtTerm.termsAgrmtPpuseScCd,
        termsAgrmtAplcScCd: this.agrmtTerm.termsAgrmtAplcScCd,
        outMngrTyp: this.agrmtTerm.outMngrTyp
      }
      console.log('confirm>>>>>>>', params)
      this.fetchData('saveTermsAgrmt', params, (data) => {
        // console.log('confirm>>>>>>>', data)
        if (data.result) {
          this.$popup.alert(this.$el, {title: '알림', contents: '이벤트 참여가 완료되었습니다.'})
        } else {
          this.$popup.alert(this.$el, {title: '알림', contents: data.result})
        }
        this.$emit('close')
      })
    },
    cancel () {
      this.$popup.confirm(this.$el, {title: '알림', contents: '이벤트 참여를 취소하시겠습니까?'}).then((result) => {
        if (result) {
          this.$emit('close')
        }
      })
    },
    modalOpen () {
      this.modalCheck = !this.modalCheck
    }
  }
}
</script>

<style scoped>
/* dimmed */
.modal-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
/* modal or popup */
.modal-container {
  position: relative;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 200px;
  width: 450px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
p {
  /* 수평 중앙 정렬하기 */
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/modal/EventJoinAgreementModal.vue